/**
 * FINANCE DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực Dịch vụ Tài chính & Fintech
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "finance",
  name: "Dịch vụ Tài chính",
  icon: "💰",
  description:
    "Tạo nội dung marketing cho ngân hàng, fintech, bảo hiểm và dịch vụ tài chính",

  // === PROJECT TYPES ===
  projectTypes: {
    "Ngân hàng": 1,
    "Fintech/Ví điện tử": 2,
    "Bảo hiểm": 3,
    "Đầu tư/Chứng khoán": 4,
    "Vay vốn/Tín dụng": 5,
    "Dịch vụ kế toán": 6,
    "Tư vấn tài chính": 7,
    Cryptocurrency: 8,
    "P2P Lending": 9,
    "Thanh toán số": 10,
  },

  // === CONTENT TYPES ===
  contentTypes: {
    "Giới thiệu sản phẩm": 1,
    "Lãi suất/Phí dịch vụ": 2,
    "Hướng dẫn sử dụng": 3,
    "Khuyến mãi/Ưu đãi": 4,
    "Phân tích thị trường": 5,
    "Tư vấn đầu tư": 6,
    "Câu chuyện khách hàng": 7,
    "Tin tức tài chính": 8,
    "Tips quản lý tiền": 9,
    "Bảo mật an toàn": 10,
    "Quy trình vay/gửi": 11,
    "Chính sách/Điều khoản": 12,
  },

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "Fintech/Ví điện tử",
    contentType: "Giới thiệu sản phẩm",
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp", "Đáng tin cậy"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại hình tài chính",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin sản phẩm tài chính",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về sản phẩm, lãi suất, điều kiện, quy trình...",
    targetCustomerLabel: "Đối tượng khách hàng",
    targetCustomerPlaceholder:
      "Mô tả đối tượng khách hàng: độ tuổi, thu nhập, nhu cầu tài chính...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    requiresLocation: false, // Dịch vụ online nhiều
    requiresPrice: true, // Lãi suất/phí quan trọng
    requiresLicense: true, // Cần giấy phép hoạt động
    requiresCompliance: true, // Tuân thủ quy định NHNN
  },
};
